export const DEFAULT_HEX_COLORS_CONFIG = [
    { color: '#000000', label: 'Black' },
    { color: '#4D4D4D', label: 'Dim grey' },
    { color: '#999999', label: 'Grey' },
    { color: '#E6E6E6', label: 'Light grey' },
    { color: '#FFFFFF', label: 'White', hasBorder: true },
    { color: '#E65C5C', label: 'Red' },
    { color: '#E69C5C', label: 'Orange' },
    { color: '#E6E65C', label: 'Yellow' },
    { color: '#C2E65C', label: 'Light green' },
    { color: '#5CE65C', label: 'Green' },
    { color: '#5CE6A6', label: 'Aquamarine' },
    { color: '#5CE6E6', label: 'Turquoise' },
    { color: '#5CA6E6', label: 'Light blue' },
    { color: '#5C5CE6', label: 'Blue' },
    { color: '#A65CE6', label: 'Purple' }
];
